import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { NumericFormat } from 'react-number-format'

import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTheme } from '@emotion/react';
import { IconButton, TableContainer, Button, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import GetAppIcon from '@mui/icons-material/GetApp';

import CategoryChip from '../../UI/CategoryChip'

import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  content: {
    padding: 0
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: '50%'
  },
  invoice_paid: {
    color: '#43a047'
  },
  invoice_open: {
    color: '#C22121'
  }
});

const InvoicesTable = props => {
  const { 
    invoices
  } = props;
  
  const classes = useClasses(styles);

  return (
    <React.Fragment>
      <CardContent sx={{padding: 0}}>
        <PerfectScrollbar>
          <TableContainer className={classes.inner}>
            <Table>
              <TableHead sx={{
                backgroundColor: "#fafafa"
              }}>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Paid?</TableCell>
                  <TableCell>Download</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoices.map(invoice => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={invoice.id}
                  >
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          {moment.unix(invoice.created).format('MM/DD/YYYY')}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <NumericFormat value={invoice.amount_due/100} displayType={'text'} prefix={'$'} thousandSeparator={true} />
                    </TableCell>
                    <TableCell>
                      {invoice.status === 'paid' ? <CheckCircleOutlineIcon className={classes.invoice_paid} />
                        : <HighlightOffIcon className={classes.invoice_open} />
                      }
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">
                          <a href={invoice.invoice_pdf}><GetAppIcon /></a>
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </CardContent>
    </React.Fragment>
  );
};

export default InvoicesTable;
